var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { BoxLeaderScoreType, SkillGroupLookupFields, ExtendedJsonRepresentations, } from "./types/core";
import { LEVEL, FUNCTION, SUB_FUNCTION } from "../../Constants";
import { reverse, sortBy } from "lodash";
import { keepPreviousData, useMutation, useQuery, } from "@tanstack/react-query";
import { queryClient } from "../../ProviderShell";
import { isLiveEnvironment, isStorybookEnvironment, } from "../../common/testHelpers";
import { FilterContext, } from "../../providers/FilterProvider";
import { useContext, useState } from "react";
import { decrementSpinReason, incrementSpinReason, } from "../../providers/SpinnerProvider";
import { FilterRestrictionContext } from "../../providers/FilterRestrictionProvider";
import { Tab } from "../../common/cohortHelpers";
import { AvailableFilters, dataFilters, getEntity } from "../../common/filters";
var getBackendBase = function (path) {
    return "".concat(new URL(process.env.REACT_APP_API_KEY).origin).concat(path);
};
export var apiBase = {
    dashboard: getBackendBase("/dashboard/api/v2"),
    ninebox: getBackendBase("/ninebox/api/v2"),
    auth: getBackendBase("/auth"),
    platform: getBackendBase(""),
};
var cohortCategoryMapping = (_a = {},
    _a[Tab.CBI] = "CBI",
    _a[Tab.SavilleWave] = "Wave",
    _a[Tab.SavilleSwiftAptitude] = "Swift",
    _a[Tab.HoganHPI] = "Hogan-HPI",
    _a[Tab.HoganHDS] = "Hogan-HDS",
    _a[Tab.HoganMVPI] = "Hogan-MVPI",
    _a[Tab.ImmersiveAgility] = "Immersive-Agility",
    _a[Tab.ImmersiveMeta] = "Immersive-Meta",
    _a);
export var mapCohortCategory = function (tab) {
    return cohortCategoryMapping[tab || ""] || [Tab.CBI];
};
export var normalizeScoreType = function (value) {
    var expectedTypes = [
        "Match",
        "Heidrick",
        "AI",
        "Functional",
        "Organizational",
        "Capabilities",
        "Potential",
    ];
    if (expectedTypes.includes(value)) {
        return value;
    }
    var mappings = {
        capability: "Capabilities",
        potential: "Potential",
        functional: "Functional",
        organizational: "Organizational",
        ai_score: "AI",
        heidrick_score: "Heidrick",
        overall_score: "Match",
    };
    return mappings[value] || value;
};
export var strengthScoreFunctor = function (assessmentIn) { return function (data) {
    var _a;
    var assessment = (assessmentIn === null || assessmentIn === void 0 ? void 0 : assessmentIn.toLowerCase()) == "capabilities"
        ? "capability"
        : assessmentIn === null || assessmentIn === void 0 ? void 0 : assessmentIn.toLowerCase();
    return assessment ? (_a = data === null || data === void 0 ? void 0 : data[assessment]) === null || _a === void 0 ? void 0 : _a.state : data === null || data === void 0 ? void 0 : data.state;
}; };
var defaultKeySet = {
    yId: "function_id",
    xIds: "sub_functions",
    xSubId: "sub_function_id",
    subs: "levels",
    subId: "level_id",
};
export var transformScores = function (_a) {
    var fillEmpty = _a.fillEmpty, keySet = _a.keySet;
    return function (data) {
        var keys = keySet || defaultKeySet;
        var getRawData = function (rawDataBreakdowns, functionIndexes, indexForLevelId) {
            var rawData = [];
            for (var _i = 0, _a = (data === null || data === void 0 ? void 0 : data.functions) || []; _i < _a.length; _i++) {
                var functionData = _a[_i];
                if (!functionIndexes[functionData[keys.yId]]) {
                    continue;
                }
                var _b = functionIndexes[functionData[keys.yId]], functionIndex = _b.functionIndex, functionName = _b.functionName, subFunctions = _b.subFunctions;
                if (!rawData[functionIndex]) {
                    rawData[functionIndex] = [];
                }
                rawData[functionIndex][0] = functionData[keys.xIds][0];
                for (var _c = 0, _d = functionData[keys.xIds][0][keys.subs]; _c < _d.length; _c++) {
                    var level = _d[_c];
                    rawData[functionIndex][indexForLevelId[level[keys.subId]]] = level;
                }
                for (var _e = 0, _f = functionData[keys.xIds].slice(1); _e < _f.length; _e++) {
                    var subFunction = _f[_e];
                    var subIndex = subFunctions[subFunction[keys.xSubId]] - 1;
                    if (!rawDataBreakdowns[functionName].data[subIndex]) {
                        rawDataBreakdowns[functionName].data[subIndex] = [];
                    }
                    rawDataBreakdowns[functionName].data[subIndex][0] = subFunction;
                    for (var _g = 0, _h = subFunction[keys.subs]; _g < _h.length; _g++) {
                        var level = _h[_g];
                        rawDataBreakdowns[functionName].data[subIndex][indexForLevelId[level[keys.subId]]] = level;
                    }
                }
            }
            return rawData;
        };
        var getDataBreakdown = function (width, rawDataBreakdowns) {
            return (Object.entries(rawDataBreakdowns || {}).reduce(function (result, _a) {
                var yHeader = _a[0], _b = _a[1], headers = _b.headers, data = _b.data;
                result[yHeader] = {
                    headers: headers,
                    data: fillEmpties(__spreadArray([], data, true), width, headers.length, fillEmpty),
                };
                return result;
            }, {}) || {});
        };
        var getCountForLevel = function (level, role) {
            if (!level || level.toLocaleLowerCase() == "all") {
                return role.leaders;
            }
            return role[keys.subs].reduce(function (count, next) {
                if (next[keys.subId] != level) {
                    return count;
                }
                return count + next.leaders;
            }, 0);
        };
        var getLeaderCount = function (level, role) {
            if (!role || role.toLocaleLowerCase() == "all") {
                return getCountForLevel(level, data.functions[0].sub_functions[0]);
            }
            else if ((role === null || role === void 0 ? void 0 : role[0]) == "F") {
                return data.functions.reduce(function (count, next) {
                    if (next[keys.yId] != role) {
                        return count;
                    }
                    return (count += getCountForLevel(level, next.sub_functions[0]));
                }, 0);
            }
            else if ((role === null || role === void 0 ? void 0 : role[0]) == "S") {
                return data.functions.reduce(function (count, next) {
                    return (count += next.sub_functions.reduce(function (innerCount, innerNext) {
                        if (innerNext.sub_function_id != role) {
                            return innerCount;
                        }
                        return (innerCount += getCountForLevel(level, innerNext));
                    }, 0));
                }, 0);
            }
            return 0;
        };
        var subFunctionsForFunctionsMap = data.functions
            .slice(1)
            .reduce(function (result, current) {
            var _a;
            return Object.assign(result, (_a = {}, _a[keys.yId] = current[keys.xIds].slice(1), _a));
        }, {});
        var functionMap = data.functions.reduce(function (result, role) {
            var _a;
            if (role[keys.yId].toUpperCase() == "ALL") {
                return result;
            }
            return Object.assign(result, (_a = {},
                _a[role[keys.yId]] = role[keys.xIds][0],
                _a));
        }, {});
        var returnable = {
            subFunctionsForFunctionsMap: subFunctionsForFunctionsMap,
            functionMap: functionMap,
            getDataBreakdown: getDataBreakdown,
            getRawData: getRawData,
            data: data,
            getLeaderCount: getLeaderCount,
        };
        return returnable;
    };
};
var fillEmpties = function (data, xLength, yLength, fillEmpty) {
    return Array.from(Array(yLength).keys()).map(function (yIndex) {
        return Array.from(Array(xLength).keys()).map(function (xIndex) { return (data[yIndex] || [])[xIndex] || fillEmpty(); });
    });
};
export var LeaderAttribute;
(function (LeaderAttribute) {
    LeaderAttribute[LeaderAttribute["All"] = 0] = "All";
    LeaderAttribute[LeaderAttribute["PrimaryRole"] = 1] = "PrimaryRole";
    LeaderAttribute[LeaderAttribute["SecondaryRole"] = 2] = "SecondaryRole";
    LeaderAttribute[LeaderAttribute["Level"] = 3] = "Level";
    LeaderAttribute[LeaderAttribute["RoleName"] = 4] = "RoleName";
})(LeaderAttribute || (LeaderAttribute = {}));
export var prepareEightfoldDomain = function (domain) {
    if (domain) {
        domain = domain.toLowerCase();
        if (!domain.startsWith("http")) {
            domain = "https://".concat(domain);
        }
        if (domain.endsWith("/")) {
            // Remove the trailing "/"
            domain = domain.substring(0, domain.length - 1);
        }
    }
    return domain;
};
export var getAttributeType = function (valueIn) {
    var value = valueIn === null || valueIn === void 0 ? void 0 : valueIn.toUpperCase();
    if (valueIn && /^L\d+S?F\d+$/.test(valueIn)) {
        return LeaderAttribute.RoleName;
    }
    return (value === null || value === void 0 ? void 0 : value[0]) == "L"
        ? LeaderAttribute.Level
        : (value === null || value === void 0 ? void 0 : value[0]) == "F"
            ? LeaderAttribute.PrimaryRole
            : (value === null || value === void 0 ? void 0 : value[0]) == "S"
                ? LeaderAttribute.SecondaryRole
                : LeaderAttribute.All;
};
var encode = function (value) {
    return encodeURIComponent(value).replaceAll("%20", "+");
};
export var getFilterParamString = function (filters) {
    var filterList = Object.entries(filters || {})
        .reduce(function (current, _a) {
        var key = _a[0], valueIn = _a[1];
        var value = (Array.isArray(valueIn) ? valueIn : valueIn != null ? [valueIn] : []).map(encode);
        if (value.length == 0 || key == "rerenderKey") {
            return current;
        }
        if (key != getEntity(AvailableFilters.AssessmentCategory)) {
            return __spreadArray(__spreadArray([], current, true), value.map(function (v) { return [key, v]; }), true);
        }
        return __spreadArray(__spreadArray([], current, true), [[key, [value === null || value === void 0 ? void 0 : value[0]]]], false);
    }, [])
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    })
        .join("&");
    if (filterList === null || filterList === void 0 ? void 0 : filterList.rerenderKey) {
        delete filterList.rerenderKey;
    }
    return filterList;
};
export var getLeaderScoresParamString = function (filters) {
    var filterString = getFilterParamString(filters);
    var query = filterString ? [filterString] : [];
    return query.join("&");
};
var permissions;
var allowedClientIds;
export var useGetPermissions = function () {
    var _a = useState(undefined), innerPermissions = _a[0], setInnerPermissions = _a[1];
    var checkSettingPermissions = function () {
        if (permissions) {
            setInnerPermissions(permissions);
        }
        else {
            setTimeout(checkSettingPermissions, 50);
        }
    };
    if (!innerPermissions && innerPermissions !== null) {
        setInnerPermissions(null);
        setTimeout(checkSettingPermissions, 50);
    }
    return innerPermissions;
};
export var useAllowedClientIds = function () {
    var _a;
    var _b = useState(undefined), data = _b[0], setData = _b[1];
    var check = function () {
        if (allowedClientIds != null) {
            setData(new Set(allowedClientIds));
        }
        else {
            setTimeout(check, 50);
        }
    };
    if (!data && data !== null) {
        setData(null);
        setTimeout(check, 50);
    }
    if (data != null) {
        return null;
    }
    return (data === null || data === void 0 ? void 0 : data.has("*"))
        ? { has: function () { return true; }, size: Infinity, one: undefined }
        : {
            has: function (clientId) { var _a; return (_a = data === null || data === void 0 ? void 0 : data.has(clientId)) !== null && _a !== void 0 ? _a : false; },
            size: (_a = data === null || data === void 0 ? void 0 : data.size) !== null && _a !== void 0 ? _a : 0,
            one: Array.from(data !== null && data !== void 0 ? data : [])[0],
        };
};
var userId;
export var useGetUserId = function () {
    var _a = useState(undefined), loggedInUserId = _a[0], setLoggedInUserId = _a[1];
    var checkLoggedInUserId = function () {
        if (permissions) {
            setLoggedInUserId(userId);
        }
        else {
            setTimeout(checkLoggedInUserId, 50);
        }
    };
    if (!loggedInUserId && loggedInUserId !== null) {
        setLoggedInUserId(null);
        setTimeout(checkLoggedInUserId, 50);
    }
    return loggedInUserId;
};
var getParamString = function (filters, leaderIdQuery, factor_id) {
    var filterString = getFilterParamString(filters);
    var query = filterString ? [filterString] : [];
    if (leaderIdQuery) {
        query.push("leader_id=".concat(encodeURIComponent(leaderIdQuery)));
    }
    if (factor_id && factor_id.toLocaleLowerCase() != "all") {
        query.push("factor_id=".concat(encodeURIComponent(factor_id)));
    }
    if (query === null || query === void 0 ? void 0 : query.rerenderKey) {
        delete query.rerenderKey;
    }
    return query.join("&");
};
var tokenFetchPromise;
export var getClientId = function () {
    var params = new window.URLSearchParams(window.location.search);
    return params.get("client");
};
var applications = [
    "PLATFORM_API",
    "ADMIN_PORTAL_UI",
    "ORG_DASHBOARD_UI",
    "ORG_DASHBOARD_API",
    "NAVIGATOR_UI",
    "SUCCESS_PROFILES_UI",
    "COHORT_INSIGHTS_UI",
    "COHORT_INSIGHTS_API",
];
var getHeaders = function () { return __awaiter(void 0, void 0, void 0, function () {
    var headers, authToken, now, tokenCheck, origin, clientId, authZUrl_1, token, e_1, authZToken;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                headers = {};
                authToken = (_c = (_b = JSON.parse((_a = localStorage.getItem("okta-token-storage")) !== null && _a !== void 0 ? _a : '{"accessToken": {"accessToken": ""}}')) === null || _b === void 0 ? void 0 : _b.accessToken) === null || _c === void 0 ? void 0 : _c.accessToken;
                if (authToken) {
                    headers.authorization = "Bearer ".concat(authToken);
                }
                if (!isLiveEnvironment()) return [3 /*break*/, 5];
                now = new Date().getTime();
                tokenCheck = localStorage.getItem("X-AUTH-Z");
                if (!(authToken &&
                    (!permissions || !tokenCheck || now > JSON.parse(tokenCheck).expires))) return [3 /*break*/, 4];
                origin = apiBase === null || apiBase === void 0 ? void 0 : apiBase.platform;
                clientId = getClientId() || "";
                authZUrl_1 = "".concat(origin, "/auth/api/v2/me?pac-applications=").concat(applications.join(","), "&pac-clientId=").concat(clientId, "&generateAuthZ=true");
                _e.label = 1;
            case 1:
                _e.trys.push([1, 3, , 4]);
                if (!tokenFetchPromise) {
                    tokenFetchPromise = (function () { return __awaiter(void 0, void 0, void 0, function () {
                        var response, tokenPayload, personaIdToClientId, _i, permissions_1, permission, jwt;
                        var _a, _b, _c, _d, _e;
                        return __generator(this, function (_f) {
                            switch (_f.label) {
                                case 0: return [4 /*yield*/, fetch(authZUrl_1, { method: "GET", headers: headers })];
                                case 1:
                                    response = _f.sent();
                                    return [4 /*yield*/, response.json()];
                                case 2:
                                    tokenPayload = _f.sent();
                                    permissions = (_a = tokenPayload === null || tokenPayload === void 0 ? void 0 : tokenPayload.data) === null || _a === void 0 ? void 0 : _a.permissions;
                                    userId = (_b = tokenPayload === null || tokenPayload === void 0 ? void 0 : tokenPayload.data) === null || _b === void 0 ? void 0 : _b.id;
                                    personaIdToClientId = (_c = tokenPayload === null || tokenPayload === void 0 ? void 0 : tokenPayload.data) === null || _c === void 0 ? void 0 : _c.myPersonas.reduce(function (result, persona) {
                                        result[persona.personaId] = persona.clientId || "*";
                                        return result;
                                    }, {});
                                    for (_i = 0, permissions_1 = permissions; _i < permissions_1.length; _i++) {
                                        permission = permissions_1[_i];
                                        if (permission.resourceName == "ORG_DASHBOARD_UI") {
                                            permission.clientIds = (_d = permission.personaIds) === null || _d === void 0 ? void 0 : _d.map(function (personaId) { return personaIdToClientId[personaId] || "*"; });
                                        }
                                        delete permission.personaIds;
                                    }
                                    jwt = (_e = tokenPayload === null || tokenPayload === void 0 ? void 0 : tokenPayload.data) === null || _e === void 0 ? void 0 : _e.jwt;
                                    if (!permissions) {
                                        throw "did not receive permissions";
                                    }
                                    if (!jwt) {
                                        throw "did not receive jwt token";
                                    }
                                    return [2 /*return*/, jwt];
                            }
                        });
                    }); })();
                }
                return [4 /*yield*/, tokenFetchPromise];
            case 2:
                token = _e.sent();
                tokenFetchPromise = undefined;
                localStorage.setItem("X-AUTH-Z", JSON.stringify({
                    token: token,
                    expires: now + 1000 * 60 * 50,
                }));
                return [3 /*break*/, 4];
            case 3:
                e_1 = _e.sent();
                tokenFetchPromise = undefined;
                console.error("error reading X-AUTH-Z token from server: " + (e_1 !== null && e_1 !== void 0 ? e_1 : "unknown error"));
                return [3 /*break*/, 4];
            case 4:
                authZToken = (_d = JSON.parse(localStorage.getItem("X-AUTH-Z") || "{}")) === null || _d === void 0 ? void 0 : _d.token;
                if (authZToken) {
                    headers["X-AUTH-Z"] = authZToken;
                }
                _e.label = 5;
            case 5: return [2 /*return*/, headers];
        }
    });
}); };
var sendRequest = function (_a) {
    var url = _a.url, method = _a.method, body = _a.body;
    return __awaiter(void 0, void 0, void 0, function () {
        var headers, response, requestParams, error_1, _b, _c;
        var _d;
        var _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0: return [4 /*yield*/, getHeaders()];
                case 1:
                    headers = _f.sent();
                    requestParams = {
                        method: method,
                        headers: headers,
                    };
                    if (body) {
                        requestParams.headers["Content-Type"] = "application/json";
                        requestParams["body"] = JSON.stringify(body);
                    }
                    _f.label = 2;
                case 2:
                    _f.trys.push([2, 4, 5, 6]);
                    incrementSpinReason();
                    return [4 /*yield*/, fetch("".concat(url), requestParams)];
                case 3:
                    response = _f.sent();
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _f.sent();
                    throw new Error("444");
                case 5:
                    decrementSpinReason();
                    return [7 /*endfinally*/];
                case 6:
                    if (!!response.ok) return [3 /*break*/, 8];
                    _b = Error.bind;
                    _c = [void 0, "".concat(response.status)];
                    _d = {};
                    return [4 /*yield*/, response.json()];
                case 7: throw new (_b.apply(Error, _c.concat([(_d.cause = _f.sent(), _d)])))();
                case 8:
                    if (!((_e = response.headers.get("content-type")) === null || _e === void 0 ? void 0 : _e.includes("text/csv"))) return [3 /*break*/, 10];
                    return [4 /*yield*/, response.text()];
                case 9: return [2 /*return*/, _f.sent()];
                case 10: return [4 /*yield*/, response.json()];
                case 11: return [2 /*return*/, _f.sent()];
            }
        });
    });
};
function doEncoding(key, value) {
    return Object.keys(apiBase).includes(key) ? value : encodeURIComponent(value);
}
function getEndpointCall(_a) {
    var _this = this;
    var endpoint = _a.endpoint, getParams = _a.getParams, selectCallback = _a.select;
    return function (query, options) {
        var shouldSkipCall = (options === null || options === void 0 ? void 0 : options.shouldSkipCall) || (function () { return false; });
        var params = getParams(query || {});
        var paramsType = typeof (params || {}).asString == "string" &&
            typeof (params || {}).asObject == "object"
            ? params
            : typeof params == "string"
                ? { asString: params, asObject: {} }
                : { asString: "", asObject: params || {} };
        var key = Object.entries(__assign({}, paramsType.asObject)).reduce(function (current, _a) {
            var key = _a[0], value = _a[1];
            if (!endpoint.includes("{".concat(key, "}"))) {
                return current;
            }
            return current.replace("{".concat(key, "}"), doEncoding(key, value));
        }, endpoint);
        var substitutedEndpoint = Object.entries(__assign(__assign({}, paramsType.asObject), apiBase)).reduce(function (current, _a) {
            var key = _a[0], value = _a[1];
            if (!endpoint.includes("{".concat(key, "}"))) {
                return current;
            }
            delete paramsType.asObject[key];
            return current.replace("{".concat(key, "}"), doEncoding(key, value));
        }, endpoint.replace("{ClientId}", getClientId() || ""));
        var paramsLead = endpoint.includes("?") ? "&" : "?";
        var paramsFromObject = Object.entries(paramsType.asObject)
            .reduce(function (current, _a) {
            var key = _a[0], value = _a[1];
            return __spreadArray(__spreadArray([], current, true), (Array.isArray(value)
                ? value.map(function (value) { return "".concat(key, "=").concat(encode(value)); })
                : ["".concat(key, "=").concat(encode(value))]), true);
        }, [])
            .join("&");
        var paramsStringSection = paramsFromObject && paramsType.asString
            ? [paramsFromObject, paramsType.asString].join("&")
            : paramsFromObject || paramsType.asString;
        var paramString = "".concat(paramsStringSection ? paramsLead : "").concat(paramsStringSection);
        var url = "".concat(substitutedEndpoint).concat(paramString.startsWith("??") ? paramString.slice(1) : paramString);
        // If any placeholder remains unsubstituted (e.g. missing reportId), avoid making a request.
        // This keeps legacy call sites from firing bad URLs while we transition to reportId-based routing.
        var hasUnsubstitutedPlaceholders = /{[^}]+}/.test(substitutedEndpoint);
        // Get the query params as an object as expected by react query
        var paramObject = paramString
            ? Object.fromEntries(new URLSearchParams(paramString))
            : {};
        if (key.includes("{ClientId}")) {
            // Remove path client ID from the key to make it easier to invalidate
            paramObject.clientId = getClientId() || "";
        }
        return useQuery(__assign(__assign({ placeholderData: keepPreviousData }, (isLiveEnvironment()
            ? {
                refetchOnWindowFocus: false,
            }
            : { retry: false })), { queryKey: [key, JSON.stringify(paramObject), paramString], queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(shouldSkipCall() || hasUnsubstitutedPlaceholders)) return [3 /*break*/, 1];
                            return [2 /*return*/, {}];
                        case 1: return [4 /*yield*/, sendRequest({ url: url, method: "GET" })];
                        case 2: return [2 /*return*/, _a.sent()];
                    }
                });
            }); }, select: function (data) {
                return selectCallback(data);
            } }));
    };
}
var mutableEndpointCall = function (endpoint, method) {
    return function (_a) {
        var invalidates = _a.invalidates, substitutions = _a.substitutions, events = _a.events;
        return useMutation({
            mutationFn: function (body) { return __awaiter(void 0, void 0, void 0, function () {
                var newBody, newEndpoint;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            newBody = __assign({}, body);
                            newEndpoint = Object.entries(__assign(__assign(__assign({}, substitutions), apiBase), body) || {}).reduce(function (result, _a) {
                                var key = _a[0], value = _a[1];
                                // Only remove from body if the endpoint contains the substitution and the key is present in body
                                if (result.includes("{".concat(key, "}")) &&
                                    Object.prototype.hasOwnProperty.call(body, key)) {
                                    delete newBody[key];
                                }
                                return result.replace("{".concat(key, "}"), value);
                            }, endpoint.replace("{ClientId}", getClientId() || ""));
                            if (!isStorybookEnvironment()) return [3 /*break*/, 1];
                            // When in Storybook, just log the output
                            console.log("".concat(method, " \"").concat(newEndpoint, "\": ").concat(JSON.stringify(newBody, null, 2)));
                            return [3 /*break*/, 3];
                        case 1: return [4 /*yield*/, sendRequest({
                                url: newEndpoint,
                                method: method,
                                body: newBody,
                            })];
                        case 2: return [2 /*return*/, _a.sent()];
                        case 3: return [2 /*return*/];
                    }
                });
            }); },
            onError: (events === null || events === void 0 ? void 0 : events.onError)
                ? function () {
                    events.onError();
                }
                : function () { return undefined; },
            onSuccess: function () {
                (function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!invalidates) return [3 /*break*/, 2];
                                return [4 /*yield*/, Promise.all(invalidates.map(function (invalidator) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, queryClient.invalidateQueries(invalidator)];
                                            case 1: return [2 /*return*/, _a.sent()];
                                        }
                                    }); }); }))];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                (events === null || events === void 0 ? void 0 : events.onSuccess) && (events === null || events === void 0 ? void 0 : events.onSuccess());
                                return [2 /*return*/];
                        }
                    });
                }); })();
            },
        });
    };
};
var createEndpointCall = function (endpoint) {
    return mutableEndpointCall(endpoint, "POST");
};
var updateEndpointCall = function (endpoint) {
    return mutableEndpointCall(endpoint, "PATCH");
};
var deleteEndpointCall = function (endpoint) {
    return mutableEndpointCall(endpoint, "DELETE");
};
var putEndpointCall = function (endpoint) {
    return mutableEndpointCall(endpoint, "PUT");
};
/* eslint-disable  @typescript-eslint/no-explicit-any */
export var selectData = function (transform) {
    return function (_a) {
        var data = _a.data;
        return transform(data);
    };
};
/* eslint-enable  @typescript-eslint/no-explicit-any */
export var transformeScoreData = selectData(function (data) {
    var transformed = transformScores({
        fillEmpty: function () { return ({ state: "nodata" }); },
    })(data);
    return transformed;
});
export var processOverviewData = function (data) {
    var primaryFunctions = data === null || data === void 0 ? void 0 : data.functions.map(function (_a) {
        var function_id = _a.function_id;
        return function_id;
    });
    var lookupCodeMap = __assign(__assign(__assign({ "All Functions": "All Functions", "All Levels": "All Levels", ALL: "All", "": "All", all: "All", All: "All" }, data === null || data === void 0 ? void 0 : data.levels.reduce(function (result, level) {
        var _a;
        return Object.assign(result, (_a = {}, _a[level.level_id] = level.level_name, _a));
    }, {})), data === null || data === void 0 ? void 0 : data.functions.reduce(function (result, function_obj) {
        var _a;
        return Object.assign(result, (_a = {},
            _a[function_obj.function_id] = function_obj.function_name,
            _a));
    }, {})), data === null || data === void 0 ? void 0 : data.sub_functions.reduce(function (result, subFunction) {
        var _a;
        return Object.assign(result, (_a = {},
            _a[subFunction.sub_function_id] = subFunction.sub_function_name,
            _a));
    }, {}));
    var subFunctionsToFunctionsMap = data === null || data === void 0 ? void 0 : data.sub_functions.reduce(function (current, _a) {
        var _b;
        var function_id = _a.function_id, sub_function_id = _a.sub_function_id;
        return Object.assign(current, (_b = {}, _b[sub_function_id] = function_id, _b));
    }, {
        "": "All",
        all: "All",
        All: "All",
    });
    var codeTypeMap = __assign(__assign(__assign({}, data === null || data === void 0 ? void 0 : data.levels.reduce(function (result, level) {
        var _a;
        return Object.assign(result, (_a = {}, _a[level.level_id] = LEVEL, _a));
    }, {})), data === null || data === void 0 ? void 0 : data.functions.reduce(function (result, function_obj) {
        var _a;
        return Object.assign(result, (_a = {},
            _a[function_obj.function_id] = FUNCTION,
            _a));
    }, {})), data === null || data === void 0 ? void 0 : data.sub_functions.reduce(function (result, subFunction) {
        var _a;
        return Object.assign(result, (_a = {},
            _a[subFunction.sub_function_id] = SUB_FUNCTION,
            _a));
    }, {}));
    var indexForLevelId = reverse(sortBy(data === null || data === void 0 ? void 0 : data.levels, "level_id")).reduce(function (result, _a, index) {
        var level_id = _a.level_id;
        result[level_id] = index + 1;
        return result;
    }, {});
    var subFunctionsForFunctions = (data === null || data === void 0 ? void 0 : data.sub_functions.reduce(function (result, element) {
        if (!result[element.function_id]) {
            result[element.function_id] = [];
        }
        result[element.function_id].push(element);
        return result;
    }, {})) || {};
    var dataBreakdownHeaders = (data === null || data === void 0 ? void 0 : data.functions.reduce(function (result, _a) {
        var function_id = _a.function_id;
        var headers = subFunctionsForFunctions[function_id].map(function (_a) {
            var sub_function_id = _a.sub_function_id;
            return sub_function_id;
        });
        result[function_id] = { headers: headers, data: [] };
        return result;
    }, {})) || {};
    var emptyFunctionIndexes = (data === null || data === void 0 ? void 0 : data.functions.reduce(function (result, _a, functionIndex) {
        var function_id = _a.function_id;
        result[function_id] = {
            functionIndex: functionIndex + 1,
            functionName: function_id,
            subFunctions: { ALL: 0 },
        };
        return result;
    }, {})) || {};
    emptyFunctionIndexes["ALL"] = {
        functionIndex: 0,
        functionName: "All Functions",
        subFunctions: {},
    };
    Object.values(dataBreakdownHeaders).forEach(function (subFunction) {
        subFunction.headers = sortBy(subFunction.headers, function (value) { return lookupCodeMap[value]; });
    });
    var sortedPrimaryFunctions = sortBy(primaryFunctions, function (value) { return lookupCodeMap[value]; });
    var functionIndexes = {
        ALL: {
            functionIndex: 0,
            functionName: "All Functions",
            subFunctions: {},
        },
    };
    sortedPrimaryFunctions.forEach(function (functionName, index) {
        var subFunctions = {
            ALL: 0,
        };
        dataBreakdownHeaders[functionName].headers.forEach(function (value, index) {
            subFunctions[value] = index + 1;
        });
        functionIndexes[functionName] = {
            functionName: functionName,
            functionIndex: index + 1,
            subFunctions: subFunctions,
        };
    });
    return {
        data: data,
        functionIndexes: functionIndexes,
        dataBreakdownHeaders: dataBreakdownHeaders,
        indexForLevelId: indexForLevelId,
        primaryFunctions: sortedPrimaryFunctions,
        lookupCodeMap: lookupCodeMap,
        subFunctionsToFunctionsMap: subFunctionsToFunctionsMap,
        codeTypeMap: codeTypeMap,
    };
};
export var useGetDownloadInformation = getEndpointCall({
    endpoint: "{platform}/attachments/api/v2/attachments/{id}/download?preSignedUrl=Y&preSignedUrlTTL=86400",
    getParams: function (_a) {
        var id = _a.id;
        return ({ id: id });
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetProject = getEndpointCall({
    endpoint: "{platform}/projects/api/v2/projects/{id}",
    getParams: function (_a) {
        var id = _a.id;
        return ({ id: id });
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
// ******************** Platform APIs ********************
export var useGetClientListPlatformQuery = getEndpointCall({
    endpoint: "{platform}/clients/api/v2/clients",
    getParams: function (_a) {
        var navigatorUrl = _a.navigatorUrl;
        return navigatorUrl
            ? "navigatorApplicationUrl=".concat(encodeURIComponent(navigatorUrl))
            : "";
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetClientPlatformQuery = getEndpointCall({
    endpoint: "{platform}/clients/api/v2/clients/{ClientId}",
    getParams: function () { return ""; },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
var getDataFiltersParamString = function (object) {
    var paramString = getFilterParamString(object);
    return "".concat(paramString ? "&".concat(paramString) : "");
};
export var useGetLeaderProfileAttributes = getEndpointCall({
    endpoint: "{platform}/leadership/api/v2/leader-profile-attributes?clientId={ClientId}",
    getParams: function (_a) {
        var clientId = _a.clientId, filters = _a.filters;
        return Object.fromEntries(Object.entries(__assign({ clientId: clientId }, filters)).filter(function (_a) {
            var v = _a[1];
            return v != null;
        }));
    },
    select: function (_a) {
        var data = _a.data;
        return ({
            data: data,
        });
    },
});
export var useGetDataCustomFiltersQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leadership/custom-data-filters",
    getParams: function (_a) {
        var clientId = _a.clientId, filters = _a.filters;
        return Object.fromEntries(Object.entries(__assign(__assign({ clientId: clientId }, filters), ((filters === null || filters === void 0 ? void 0 : filters.assessmentCategory)
            ? {
                assessmentCategory: cohortCategoryMapping[filters.assessmentCategory || ""] || filters.assessmentCategory,
            }
            : {}))).filter(function (_a) {
            var k = _a[0], v = _a[1];
            return v != null && k != "rerenderKey";
        }));
    },
    select: function (_a) {
        var data = _a.data;
        return ({
            data: data,
            indexed: data.reduce(function (current, _a) {
                var _b;
                var filterKey = _a.filterKey, filterLabel = _a.filterLabel, filterOptions = _a.filterOptions;
                return (__assign(__assign({}, current), (_b = {}, _b[filterKey] = {
                    value: filterKey,
                    label: filterLabel,
                    options: filterOptions.map(function (entry) {
                        var _a, _b;
                        return ({
                            value: (_a = entry === null || entry === void 0 ? void 0 : entry.value) !== null && _a !== void 0 ? _a : entry,
                            label: (_b = entry === null || entry === void 0 ? void 0 : entry.label) !== null && _b !== void 0 ? _b : entry,
                        });
                    }),
                }, _b)));
            }, {}),
        });
    },
});
export var useGetDataFiltersQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leadership/data-filters",
    getParams: function (_a) {
        var clientId = _a.clientId, filters = _a.filters;
        var race = filters === null || filters === void 0 ? void 0 : filters.ethnicity;
        var adjusted = __assign(__assign({}, (filters || {})), { race: race, assessmentCategory: cohortCategoryMapping[(filters === null || filters === void 0 ? void 0 : filters.assessmentCategory) || ""] ||
                (filters === null || filters === void 0 ? void 0 : filters.assessmentCategory) });
        var params = "clientId=".concat(encodeURIComponent(clientId || "Master")).concat(getDataFiltersParamString(adjusted));
        return params;
    },
    select: function (_a) {
        var _b;
        var data = _a.data;
        // Most filters have the same label and value, but these have different ones
        var filtersWithLabels = (_b = {},
            _b[dataFilters[AvailableFilters.Managers].entity] = {
                label: "fullName",
                value: "email",
            },
            _b[dataFilters[AvailableFilters.Roles].entity] = {
                label: "roleName",
                value: "roleProfileId",
            },
            _b[dataFilters[AvailableFilters.Project].entity] = {
                label: "projectName",
                value: "projectId",
            },
            _b);
        return {
            data: Object.entries(data).reduce(function (current, _a) {
                var _b;
                var entity = _a[0], values = _a[1];
                return (__assign(__assign({}, current), (_b = {}, _b[entity] = values
                    .filter(function (value) {
                    return filtersWithLabels[entity]
                        ? value[filtersWithLabels[entity].value]
                        : value;
                })
                    .map(function (value) {
                    if (filtersWithLabels[entity]) {
                        return {
                            label: value[filtersWithLabels[entity].label],
                            value: value[filtersWithLabels[entity].value],
                        };
                    }
                    return {
                        label: value,
                        value: value,
                    };
                }), _b)));
            }, {}),
        };
    },
});
var definedExtendedRepresentations = new Set(Object.keys(ExtendedJsonRepresentations));
var getJsonFromExtended = function (data) {
    if (data == null) {
        return data;
    }
    else if (Array.isArray(data)) {
        return data.map(getJsonFromExtended);
    }
    else if (typeof data === "object") {
        var keys = Object.keys(data);
        var extendedKey = keys.find(function (key) {
            return definedExtendedRepresentations.has(key);
        });
        if (extendedKey) {
            return ExtendedJsonRepresentations[extendedKey](data);
        }
        return keys.reduce(function (current, key) {
            var _a;
            return (__assign(__assign({}, current), (_a = {}, _a[key] = getJsonFromExtended(data[key]), _a)));
        }, {});
    }
    return data;
};
export var useGetBubbleBuckets = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/{reportId}/bubble-chart-agg",
    getParams: function (_a) {
        var filters = _a.filters, reportId = _a.reportId, skill = _a.skill, skillGroup = _a.skillGroup;
        return {
            asString: getFilterParamString(filters),
            asObject: __assign(__assign(__assign({}, (reportId ? { reportId: reportId } : {})), (skill && skill !== "Overall" ? { skill: skill } : {})), (skillGroup ? { skill_group: skillGroup } : {})),
        };
    },
    select: function (_a) {
        var data = _a.data;
        return getJsonFromExtended(data);
    },
});
export var useGetRoleProfileListQuery = getEndpointCall({
    endpoint: "{platform}/leadership/api/v2/role-profiles",
    getParams: function (_a) {
        var _b, _c, _d, _e;
        var clientId = _a.clientId, limit = _a.limit, offset = _a.offset, sort = _a.sort, filters = _a.filters, status = _a.status;
        var params = "clientId=".concat(encodeURIComponent(clientId || "Master"));
        if (status) {
            params += "&status=".concat(encodeURIComponent(status));
        }
        if (filters) {
            if (filters === null || filters === void 0 ? void 0 : filters.roleName) {
                params += "&roleName=".concat(encodeURIComponent(filters.roleName));
            }
            if ((_b = filters === null || filters === void 0 ? void 0 : filters[getEntity(AvailableFilters.BusinessFunctions)]) === null || _b === void 0 ? void 0 : _b[0]) {
                params += "&functionCode=".concat((_c = filters === null || filters === void 0 ? void 0 : filters[getEntity(AvailableFilters.BusinessFunctions)]) === null || _c === void 0 ? void 0 : _c.map(encode).join(","));
            }
            if ((_d = filters === null || filters === void 0 ? void 0 : filters[getEntity(AvailableFilters.BusinessSubFunctions)]) === null || _d === void 0 ? void 0 : _d[0]) {
                params += "&subFunctionCode=".concat((_e = filters === null || filters === void 0 ? void 0 : filters[getEntity(AvailableFilters.BusinessSubFunctions)]) === null || _e === void 0 ? void 0 : _e.map(encode).join(","));
            }
            if ((filters === null || filters === void 0 ? void 0 : filters.level) !== undefined) {
                params += "&levelCode=".concat(filters === null || filters === void 0 ? void 0 : filters.level.map(encode).join(","));
            }
            if (filters === null || filters === void 0 ? void 0 : filters.statement) {
                // Extract the `id` values from the array of objects in `filters.statement`
                var statementIds = filters === null || filters === void 0 ? void 0 : filters.statement.map(function (item) { return item.id || item; });
                params += "&statementIds=".concat(statementIds.map(encode).join(","));
            }
        }
        if (Number.isInteger(limit) && Number.isInteger(offset)) {
            params += "&limit=".concat(encodeURIComponent(limit), "&offset=").concat(encodeURIComponent(offset));
        }
        if (sort && sort.length > 0) {
            var sortParams = sort.map(function (sortItem) { return encodeURIComponent(sortItem); });
            params += "&sort=".concat(sortParams.join(","));
        }
        return params;
    },
    select: function (_a) {
        var data = _a.data, metadata = _a.metadata;
        return ({ data: data, metadata: metadata });
    },
});
export var updateSkill = updateEndpointCall("{platform}/leadership/api/v2/skills/{id}");
export var useGetUsers = getEndpointCall({
    endpoint: "{auth}/api/v2/users",
    getParams: function (_a) {
        var clientId = _a.clientId;
        return "clientId=".concat(clientId);
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetSkillsCategoryQuery = getEndpointCall({
    endpoint: "{platform}/leadership/api/v2/skill-categories",
    getParams: function (_a) {
        var clientId = _a.clientId, roleProfileId = _a.roleProfileId, levelCode = _a.levelCode, filters = _a.filters, name = _a.name, limit = _a.limit, offset = _a.offset;
        var params = "clientId=".concat(encodeURIComponent(clientId || "Master"));
        if (roleProfileId) {
            params += "&roleProfileId=".concat(encodeURIComponent(roleProfileId));
        }
        if (name) {
            params += "&name=".concat(encodeURIComponent(name));
        }
        if (levelCode) {
            params += "&levelCode=".concat(encodeURIComponent(levelCode));
        }
        if (filters) {
            params += appendedSkillCategoriesParameters(filters);
        }
        params += "&unmodifiedResult=true";
        if (Number.isInteger(limit) && Number.isInteger(offset)) {
            params += "&limit=".concat(encodeURIComponent(limit), "&offset=").concat(encodeURIComponent(offset));
        }
        return params;
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
var appendedStatementLibrariesParameters = function (filters, clientId) {
    if (!filters) {
        return "";
    }
    var result = "";
    if (filters.subFunctionFilter && clientId !== "Master") {
        result += "&subFunctionTags=".concat(filters === null || filters === void 0 ? void 0 : filters.subFunctionFilter.map(encode).join(","));
    }
    if (filters.level && clientId !== "Master") {
        result += "&levelTags=".concat(filters === null || filters === void 0 ? void 0 : filters.level.map(encode).join(","));
    }
    return result;
};
var appendedSkillCategoriesParameters = function (filters) {
    if (!filters) {
        return "";
    }
    var result = "";
    if ((filters === null || filters === void 0 ? void 0 : filters.functionFilter) !== undefined) {
        result += "&functionCodes=".concat(filters.functionFilter.map(encode).join(","));
    }
    if ((filters === null || filters === void 0 ? void 0 : filters.subFunctionFilter) !== undefined) {
        result += "&subFunctionCodes=".concat(filters.subFunctionFilter
            .map(encode)
            .join(","));
    }
    if ((filters === null || filters === void 0 ? void 0 : filters.level) !== undefined) {
        result += "&levelCodes=".concat(filters.level.map(encode).join(","));
    }
    return result;
};
export var useGetProjects = getEndpointCall({
    endpoint: "{platform}/projects/api/v2/projects?clientId={ClientId}&fields=name,purpose,isCohortAnonymized",
    getParams: function () { return ({}); },
    select: function (_a) {
        var data = _a.data;
        return ({
            data: data,
            indexed: (data === null || data === void 0 ? void 0 : data.reduce(function (acc, project) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[project.id] = project, _a)));
            }, {})) || {},
        });
    },
});
export var SkillGroup;
(function (SkillGroup) {
    SkillGroup["Organizational"] = "Organizational Impact";
    SkillGroup["Functional"] = "Functional Impact";
    SkillGroup["All"] = "Organizational Impact,Functional Impact";
})(SkillGroup || (SkillGroup = {}));
export var useGetStatementLibrariesQuery = getEndpointCall({
    endpoint: "{platform}/leadership/api/v2/statement-libraries",
    getParams: function (_a) {
        var clientId = _a.clientId, skillGroup = _a.skillGroup, limit = _a.limit, offset = _a.offset, sort = _a.sort, name = _a.name, filters = _a.filters;
        var params = "clientId=".concat(encodeURIComponent(clientId || "Master"));
        if (name) {
            params += "&name=".concat(encodeURIComponent(name));
        }
        if (skillGroup) {
            params += "&skillGroup=".concat(encodeURIComponent(skillGroup));
        }
        if (Number.isInteger(limit) && Number.isInteger(offset)) {
            params += "&limit=".concat(encodeURIComponent(limit), "&offset=").concat(encodeURIComponent(offset));
        }
        if (sort && sort.length > 0) {
            var sortParams = sort.map(function (sortItem) { return encodeURIComponent(sortItem); });
            params += "&sort=".concat(sortParams.join(","));
        }
        if (filters || clientId) {
            params += appendedStatementLibrariesParameters(filters, clientId);
        }
        return params;
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetLookupsQuery = getEndpointCall({
    endpoint: "{platform}/leadership/api/v2/lookups",
    getParams: function (_a) {
        var clientId = _a.clientId;
        return "clientId=".concat(encodeURIComponent(clientId || "Master"), "&lookUpTypesList=Level,Importance Rating,Impact Module");
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetLookupsFiltersQuery = getEndpointCall({
    endpoint: "{platform}/leadership/api/v2/lookups",
    getParams: function (_a) {
        var clientId = _a.clientId;
        return "clientId=".concat(encodeURIComponent(clientId || "Master"), "&lookUpTypesList=Level");
    },
    select: function (_a) {
        var _b;
        var data = _a.data;
        var platformOptionToUs = function (func) { return ({
            label: func.fieldValue,
            value: func.code,
        }); };
        var functions = data === null || data === void 0 ? void 0 : data[0].functions.map(platformOptionToUs);
        var subFunctions = data === null || data === void 0 ? void 0 : data[0].functions.map(function (_a) {
            var subFunctions = _a.subFunctions;
            return (subFunctions === null || subFunctions === void 0 ? void 0 : subFunctions.map(platformOptionToUs)) || [];
        }).flat();
        var levels = data === null || data === void 0 ? void 0 : data[0].lookUpTypes.find(function (lookUpType) { return lookUpType.lookupName == "Level"; }).lookupValues.map(function (level) { return ({
            label: level.fieldValue,
            value: level.code,
        }); });
        var lookupCodeMap = [functions, subFunctions, levels].reduce(function (current, mappings) {
            mappings.forEach(function (_a) {
                var label = _a.label, value = _a.value;
                current[value] = label;
            });
            return current;
        }, {
            "": "All",
            ALL: "All",
            All: "All",
            "All Functions": "All Functions",
            "All Levels": "All Levels",
        });
        return {
            data: (_b = {},
                _b[getEntity(AvailableFilters.BusinessFunctions)] = functions,
                _b[getEntity(AvailableFilters.BusinessSubFunctions)] = subFunctions,
                _b.level = levels,
                _b.lookupCodeMap = lookupCodeMap,
                _b),
        };
    },
});
var getScoresFromProject = function (_a) {
    var functions = _a.functions;
    var values = (functions === null || functions === void 0 ? void 0 : functions[0]) ? __assign({}, functions === null || functions === void 0 ? void 0 : functions[0]) : {};
    return values;
};
var spreadProjectIds = function (project) {
    var _a;
    return ({
        functions: ((_a = project === null || project === void 0 ? void 0 : project.functions) === null || _a === void 0 ? void 0 : _a.map(function (funkshun) { return (__assign(__assign({}, funkshun), { project_id: project === null || project === void 0 ? void 0 : project.project_id })); })) || [],
        project_id: project === null || project === void 0 ? void 0 : project.project_id,
    });
};
export var useGetProjectFunctions = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/{reportId}/project-function-agg",
    getParams: function (_a) {
        var filters = _a.filters, reportId = _a.reportId, skillGroup = _a.skillGroup;
        var filterString = getParamString(filters) || "";
        var skillGroupString = "skill_group=".concat(encodeURIComponent(skillGroup));
        return {
            asString: "".concat(filterString).concat(filterString.length === 0 ? "" : "&").concat(skillGroupString),
            asObject: __assign({}, (reportId ? { reportId: reportId } : {})),
        };
    },
    select: function (_a) {
        var data = _a.data;
        var projects = (data === null || data === void 0 ? void 0 : data.projects.map(spreadProjectIds).map(function (project) { return (__assign({ sub_projects: [
                __assign({ sub_project_id: "ALL", functions: project.functions }, getScoresFromProject(project)),
            ] }, project)); })) || [];
        var transformed = transformScores({
            fillEmpty: function () { return ({ state: "nodata" }); },
            keySet: {
                yId: "project_id",
                xIds: "sub_projects",
                xSubId: "sub_project_id",
                subs: "functions",
                subId: "function_id",
            },
        })({ functions: projects });
        return transformed;
    },
});
export var useGetHeatmapAggregation = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/heatmap-aggregation/{reportId}",
    getParams: function (_a) {
        var filters = _a.filters, reportId = _a.reportId, skillGroup = _a.skillGroup;
        var filterString = getParamString(filters) || "";
        var skillGroupString = "skill_group=".concat(encodeURIComponent(skillGroup));
        return {
            asString: "".concat(filterString).concat(filterString.length === 0 ? "" : "&").concat(skillGroupString),
            asObject: __assign({}, (reportId ? { reportId: reportId } : {})),
        };
    },
    select: function (_a) {
        var data = _a.data;
        return (Array.isArray(data) ? data : []);
    },
});
export var useGetClientModelsQuery = getEndpointCall({
    endpoint: "{platform}/leadership/api/v2/client-models",
    getParams: function (_a) {
        var clientId = _a.clientId, skillGroupName = _a.skillGroupName;
        return "clientId=".concat(encodeURIComponent(clientId || "Master"), "&skillGroupName=").concat(encodeURIComponent(skillGroupName));
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useSuccessProfileDownloadReport = createEndpointCall("{platform}/assessment-reports/v2/generator");
export var useGetSkillGroupLookupsQuery = getEndpointCall({
    endpoint: "{platform}/leadership/api/v2/skill-groups-lookup",
    getParams: function (_a) {
        var clientId = _a.clientId;
        return "clientId=".concat(encodeURIComponent(clientId || "Master"));
    },
    select: function (_a) {
        var data = _a.data;
        var lookupType = {
            funcImpact: "",
            orgImpact: "",
            capability: "",
            potential: "",
        };
        data.forEach(function (item) {
            if (item.fieldValue == SkillGroupLookupFields.funcImpact) {
                lookupType.funcImpact = item["fieldLabel"];
            }
            if (item.fieldValue == SkillGroupLookupFields.orgImpact) {
                lookupType.orgImpact = item["fieldLabel"];
            }
            if (item.fieldValue == SkillGroupLookupFields.capability) {
                lookupType.capability = item["fieldLabel"];
            }
            if (item.fieldValue == SkillGroupLookupFields.potential) {
                lookupType.potential = item["fieldLabel"];
            }
        });
        return lookupType;
    },
});
export var useGetProjectListAggregateQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/{reportId}/distinct-projects",
    getParams: function (_a) {
        var filters = _a.filters, reportId = _a.reportId;
        var filterString = getFilterParamString(filters) || "";
        return {
            asString: "".concat(filterString).concat(filterString.length === 0 ? "" : "&"),
            asObject: __assign({}, (reportId ? { reportId: reportId } : {})),
        };
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
// ******************** General APIs ********************
export var useGetClientDetailsQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/client-details",
    getParams: function () { return ""; },
    select: function (data) { return data; },
});
export var updateClientDetailsQuery = updateEndpointCall("{dashboard}/{ClientId}/client-details");
export var useGetUserDetailsQuery = getEndpointCall({
    endpoint: "{dashboard}/user-details",
    getParams: function () { return ""; },
    select: selectData(function (data) { return data; }),
});
// ******************** Leadership Summary APIs ********************
export var useGetLeadershipOverviewQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leadership/overview",
    getParams: function (_a) {
        var filters = _a.filters;
        return getFilterParamString(filters);
    },
    select: selectData(processOverviewData),
});
export var useGetLeadershipScoresQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leadership/scores",
    getParams: function (_a) {
        var filters = _a.filters;
        return getFilterParamString(filters);
    },
    select: selectData(function (data) {
        var transformed = transformScores({
            fillEmpty: function () { return ({ state: "nodata" }); },
        })(data);
        return transformed;
    }),
});
export var useGetLeadershipRisksQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leadership/risks",
    getParams: function (_a) {
        var filters = _a.filters, scoreType = _a.scoreType, role = _a.role;
        if (filters) {
            var params = [
                "score_type=".concat(normalizeScoreType(scoreType || (filters === null || filters === void 0 ? void 0 : filters.scoreType))),
            ];
            var paramString = getParamString(filters);
            if (paramString) {
                params.push(paramString);
            }
            return params.join("&");
        }
        var otherParams = getParamString({ locations: [], role: role });
        if (otherParams) {
            return [
                otherParams,
                "score_type=".concat(normalizeScoreType(scoreType || (filters === null || filters === void 0 ? void 0 : filters.scoreType))),
            ].join("&");
        }
        return "score_type=".concat(normalizeScoreType(scoreType || (filters === null || filters === void 0 ? void 0 : filters.scoreType)));
    },
    select: selectData(function (data) {
        var getRiskyLeader = function (id) {
            return data === null || data === void 0 ? void 0 : data.high_risk_entities.find(function (_a) {
                var leader_id = _a.leader_id;
                return leader_id == id;
            });
        };
        return { data: data, getRiskyLeader: getRiskyLeader };
    }),
});
export var useGetLeadershipThresholdsQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leadership/threshold",
    getParams: function (_a) {
        var scoreType = _a.scoreType;
        return "score_type=".concat(normalizeScoreType(scoreType));
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetLeadersLowScoreThresholdsQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leadership/low-score-threshold",
    getParams: function (_a) {
        var scoreType = _a.scoreType;
        return "score_type=".concat(normalizeScoreType(scoreType));
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetScoreStateQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leadership/state",
    getParams: function (_a) {
        var filters = _a.filters;
        return getLeaderScoresParamString(filters);
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetLeaderScoresQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leadership/leader-scores",
    getParams: function (_a) {
        var filters = _a.filters;
        return getLeaderScoresParamString(filters);
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetLeaderScoreAggByAssessmentQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/{reportId}/leader-scores-agg-assessment-chart",
    getParams: function (_a) {
        var reportId = _a.reportId, filters = _a.filters, skillGroup = _a.skillGroup, skill = _a.skill;
        var filterParams = getFilterParamString(filters);
        var params = "";
        if (skillGroup) {
            params += "skill_group=".concat(encodeURIComponent(skillGroup));
        }
        if (skill) {
            params += "".concat(params ? "&" : "", "skill=").concat(encodeURIComponent(skill));
        }
        if (filterParams) {
            params += "".concat(params ? "&" : "").concat(filterParams);
        }
        return {
            asString: params,
            asObject: __assign({}, (reportId ? { reportId: reportId } : {})),
        };
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetCohortLeaderCountQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/cohort-leader-count",
    getParams: function (_a) {
        var filters = _a.filters;
        return getLeaderScoresParamString(filters);
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetScoreByFactorQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leadership/scores-by-factor",
    getParams: function (_a) {
        var filters = _a.filters, skillGroup = _a.skillGroup, subFunction = _a.subFunction;
        var filterParams = getFilterParamString(filters);
        var params = [];
        if (skillGroup) {
            params.push("skill_group=".concat(encodeURIComponent(skillGroup)));
        }
        if (subFunction) {
            params.push("sub_function=".concat(encodeURIComponent(subFunction)));
        }
        if (filterParams) {
            return "".concat(params ? "".concat(params.join("&"), "&") : "").concat(filterParams);
        }
        return params.join("&");
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
// ******************** Leaders at Risk APIs ********************
export var useGetLeaderAtRiskOverviewQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leadership/leaders-at-risk/overview",
    getParams: function () { return ""; },
    select: selectData(processOverviewData),
});
export var useGetLeaderAtRiskScoresQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leadership/leaders-at-risk/scores",
    getParams: function (_a) {
        var filters = _a.filters;
        return getFilterParamString(filters);
    },
    select: selectData(function (data) {
        var transformed = transformScores({
            fillEmpty: function () { return ({ state: "nodata" }); },
        })(data);
        return transformed;
    }),
});
export var useGetLeadersAtRiskThresholdsQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leadership/leaders-at-risk/threshold",
    getParams: function (_a) {
        var scoreType = _a.scoreType;
        return "score_type=".concat(normalizeScoreType(scoreType));
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetLeadersAtRiskRisksQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leadership/leaders-at-risk/risks",
    getParams: function (_a) {
        var filters = _a.filters, scoreType = _a.scoreType, role = _a.role;
        if (filters) {
            var params = [
                "score_type=".concat(normalizeScoreType(scoreType || (filters === null || filters === void 0 ? void 0 : filters.scoreType))),
            ];
            var paramString = getParamString(filters);
            if (paramString) {
                params.push(paramString);
            }
            return params.join("&");
        }
        var otherParams = getParamString({ locations: [], role: role });
        if (otherParams) {
            return [
                otherParams,
                "score_type=".concat(normalizeScoreType(scoreType || (filters === null || filters === void 0 ? void 0 : filters.scoreType))),
            ].join("&");
        }
        return "score_type=".concat(normalizeScoreType(scoreType || (filters === null || filters === void 0 ? void 0 : filters.scoreType)));
    },
    select: selectData(function (data) {
        var getRiskyLeader = function (id) {
            return data === null || data === void 0 ? void 0 : data.high_risk_entities.find(function (_a) {
                var leader_id = _a.leader_id;
                return leader_id == id;
            });
        };
        return { data: data, getRiskyLeader: getRiskyLeader };
    }),
});
// ******************** Position Succession APIs ********************
export var useGetPositionSuccessionOverviewQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/position-succession/overview",
    getParams: function () { return ""; },
    select: selectData(processOverviewData),
});
export var useGetPositionSuccessionScoresQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/position-succession/scores",
    getParams: function (_a) {
        var filters = _a.filters;
        return getFilterParamString(filters);
    },
    select: selectData(function (data) {
        var transformed = transformScores({
            fillEmpty: function () { return ({ state: "nodata" }); },
        })(data);
        return transformed;
    }),
});
export var useGetPositionSuccessionRisksQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/position-succession/risks",
    getParams: function (_a) {
        var filters = _a.filters, scoreType = _a.scoreType, role = _a.role;
        if (filters) {
            var params = [
                "score_type=".concat(normalizeScoreType(scoreType || (filters === null || filters === void 0 ? void 0 : filters.scoreType))),
            ];
            var paramString = getParamString(filters);
            if (paramString) {
                params.push(paramString);
            }
            return params.join("&");
        }
        var otherParams = getParamString({ locations: [], role: role });
        if (otherParams) {
            return [
                otherParams,
                "score_type=".concat(normalizeScoreType(scoreType || (filters === null || filters === void 0 ? void 0 : filters.scoreType))),
            ].join("&");
        }
        return "score_type=".concat(normalizeScoreType(scoreType || (filters === null || filters === void 0 ? void 0 : filters.scoreType)));
    },
    select: selectData(function (data) {
        var getRiskyLeader = function (id) {
            return data === null || data === void 0 ? void 0 : data.high_risk_entities.find(function (_a) {
                var leader_id = _a.leader_id;
                return leader_id == id;
            });
        };
        return { data: data, getRiskyLeader: getRiskyLeader };
    }),
});
export var useGetPositionSuccessionThresholdsQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/position-succession/threshold",
    getParams: function (_a) {
        var scoreType = _a.scoreType;
        return "score_type=".concat(normalizeScoreType(scoreType));
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetPositionedSuccessionLeaderScoresQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/position-succession/leader-scores",
    getParams: function (_a) {
        var filters = _a.filters;
        return getLeaderScoresParamString(filters);
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetPositionSuccessionDownloadQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/position-succession/leader-scores/download",
    getParams: function (_a) {
        var filters = _a.filters, scoreType = _a.scoreType;
        var params = [
            "score_type=".concat(normalizeScoreType(scoreType || (filters === null || filters === void 0 ? void 0 : filters.scoreType))),
        ];
        if (filters) {
            var paramString = getLeaderScoresParamString(filters);
            if (paramString) {
                params.push(paramString);
            }
            return params.join("&");
        }
        return params.join("&");
    },
    select: selectData(processOverviewData),
});
export var useGetPositionedRecommendedSuccessors = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/position-succession/{leaderId}/recommended-successors",
    getParams: function (_a) {
        var leaderId = _a.leaderId;
        return ({ leaderId: leaderId });
    },
    select: selectData(function (data) { return data; }),
});
// ******************** Leader Succession APIs ********************
export var useGetLeaderedSuccessionOverviewQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leader-succession/overview",
    getParams: function () { return ""; },
    select: selectData(processOverviewData),
});
export var useGetLeaderedSuccessionScoresQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leader-succession/scores",
    getParams: function (_a) {
        var filters = _a.filters;
        return getFilterParamString(filters);
    },
    select: selectData(function (data) {
        var transformed = transformScores({
            fillEmpty: function () { return ({ state: "nodata" }); },
        })(data);
        return transformed;
    }),
});
export var useGetLeaderedSuccessionRisksQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leader-succession/risks",
    getParams: function (_a) {
        var filters = _a.filters, scoreType = _a.scoreType, role = _a.role;
        if (filters) {
            var params = [
                "score_type=".concat(normalizeScoreType(scoreType || (filters === null || filters === void 0 ? void 0 : filters.scoreType))),
            ];
            var paramString = getParamString(filters);
            if (paramString) {
                params.push(paramString);
            }
            return params.join("&");
        }
        var otherParams = getParamString({ locations: [], role: role });
        if (otherParams) {
            return [
                otherParams,
                "score_type=".concat(normalizeScoreType(scoreType || (filters === null || filters === void 0 ? void 0 : filters.scoreType))),
            ].join("&");
        }
        return "score_type=".concat(normalizeScoreType(scoreType || (filters === null || filters === void 0 ? void 0 : filters.scoreType)));
    },
    select: selectData(function (data) {
        var getRiskyLeader = function (id) {
            return data === null || data === void 0 ? void 0 : data.high_risk_entities.find(function (_a) {
                var leader_id = _a.leader_id;
                return leader_id == id;
            });
        };
        return { data: data, getRiskyLeader: getRiskyLeader };
    }),
});
export var useGetLeaderedSuccessionThresholdsQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leader-succession/threshold",
    getParams: function (_a) {
        var scoreType = _a.scoreType;
        return "score_type=".concat(normalizeScoreType(scoreType));
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetLeaderedSuccessionLeaderScoresQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leader-succession/leader-scores",
    getParams: function (_a) {
        var filters = _a.filters;
        return getLeaderScoresParamString(filters);
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
// ******************** Leader Diversity APIs   ********************
export var useGetDiversityLeaders = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leaders",
    getParams: function (_a) {
        var filters = _a.filters;
        var filterParams = getLeaderScoresParamString(__assign({}, filters));
        return filterParams
            ? "".concat(filterParams, "&data_model=diversity")
            : "data_model=diversity";
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
// ******************** Cohort Insights ********************
var assessmentCategoryMap = {
    "Saville Wave": Tab.SavilleWave,
    "Saville Swift": Tab.SavilleSwiftAptitude,
    CBI: Tab.CBI,
    "Hogan HPI": Tab.HoganHPI,
    "Hogan HDS": Tab.HoganHDS,
    "Hogan MVPI": Tab.HoganMVPI,
    "Immersive Agility": Tab.ImmersiveAgility,
    "Immersive META": Tab.ImmersiveMeta,
    "Immersive-Meta": Tab.ImmersiveMeta,
};
export var useGetLeaderScoresAssessmentAggByFactorQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/{reportId}/leader-scores-assessment-aggby-factor",
    getParams: function (_a) {
        var filters = _a.filters, reportId = _a.reportId;
        var filtersWithoutCategory = __assign({}, (filters || {}));
        delete filtersWithoutCategory[getEntity(AvailableFilters.AssessmentCategory)];
        var filterParams = getFilterParamString(filtersWithoutCategory);
        return {
            asString: filterParams ? "".concat(filterParams) : "",
            asObject: __assign({}, (reportId ? { reportId: reportId } : {})),
        };
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetCohortAvailableAssessmentsQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/cohort-report/available-assessments",
    getParams: function () { return ({}); },
    select: function (_a) {
        var data = _a.data;
        return ({
            data: {
                assessments: data.assessments.map(function (assessment) {
                    // Map display names to Tab enum values
                    var assessmentValueMap = {
                        "Saville Wave": Tab.SavilleWave,
                        "Saville Swift": Tab.SavilleSwiftAptitude,
                        CBI: Tab.CBI,
                        "Hogan HPI": Tab.HoganHPI,
                        "Hogan HDS": Tab.HoganHDS,
                        "Hogan MVPI": Tab.HoganMVPI,
                        "Immersive Agility": Tab.ImmersiveAgility,
                        "Immersive META": Tab.ImmersiveMeta,
                    };
                    return __assign(__assign({}, assessment), { name: assessmentValueMap[assessment.name] || assessment.name });
                }),
            },
        });
    },
});
export var useGetCohortReportLeaderCount = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/{".concat(getEntity(AvailableFilters.AssessmentCategory), "}/cohort-report/leader-count"),
    getParams: function (_a) {
        var _b, _c;
        var category = _a.category, filters = _a.filters;
        var filterString = getFilterParamString(__assign(__assign({}, filters), (_b = {}, _b[getEntity(AvailableFilters.AssessmentCategory)] = category, _b)));
        return {
            asString: filterString || "",
            asObject: (_c = {},
                _c[getEntity(AvailableFilters.AssessmentCategory)] = mapCohortCategory(category),
                _c),
        };
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
var leaderTableNormalizationConfig = {
    rowCollections: ["leaders_at_skill_level", "leaders_at_skillgroup_level"],
    attributes: [
        "column1Attribute",
        "column2Attribute",
        "belowNameAttribute",
    ],
};
var normalizeLeaderTableResponse = function (data) {
    var leaderTableOptions = (data === null || data === void 0 ? void 0 : data.leader_table_options) || (data === null || data === void 0 ? void 0 : data.leaderTableOptions) || {};
    var resolvedAttributes = leaderTableNormalizationConfig.attributes.reduce(function (current, attributeKey) {
        var _a;
        return (__assign(__assign({}, current), (_a = {}, _a[attributeKey] = (data === null || data === void 0 ? void 0 : data[attributeKey]) || (leaderTableOptions === null || leaderTableOptions === void 0 ? void 0 : leaderTableOptions[attributeKey]), _a)));
    }, {});
    var normalized = __assign(__assign({}, data), resolvedAttributes);
    leaderTableNormalizationConfig.rowCollections.forEach(function (rowKey) {
        var rows = Array.isArray(data === null || data === void 0 ? void 0 : data[rowKey]) ? data[rowKey] : [];
        normalized[rowKey] = rows.map(function (row) {
            var rowCopy = __assign({}, row);
            leaderTableNormalizationConfig.attributes.forEach(function (attributeKey) {
                var dynamicAttribute = resolvedAttributes[attributeKey];
                if (!dynamicAttribute) {
                    return;
                }
                if (rowCopy[dynamicAttribute] == null &&
                    rowCopy[attributeKey] != null) {
                    rowCopy[dynamicAttribute] = rowCopy[attributeKey];
                }
                if (rowCopy[attributeKey] == null &&
                    rowCopy[dynamicAttribute] != null) {
                    rowCopy[attributeKey] = rowCopy[dynamicAttribute];
                }
            });
            return rowCopy;
        });
    });
    return normalized;
};
export var useGetLeaderScoresAssessmentAggBySkillsQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/{reportId}/leader-scores-assessment-aggby-skill",
    getParams: function (_a) {
        var filters = _a.filters, reportId = _a.reportId, skillGroup = _a.skillGroup, skill = _a.skill;
        var filterParams = getFilterParamString(filters);
        var params = "";
        if (skillGroup) {
            params += "skill_group=".concat(encodeURIComponent(skillGroup));
        }
        if (skill) {
            params += "".concat(params ? "&" : "", "skill=").concat(encodeURIComponent(skill));
        }
        if (filterParams) {
            params += "".concat(params ? "&" : "").concat(filterParams);
        }
        return {
            asString: params,
            asObject: __assign({}, (reportId ? { reportId: reportId } : {})),
        };
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: normalizeLeaderTableResponse(data) });
    },
});
export var useGetLeaderCustomScoresAssessmentAggBySkillGroupQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leader-scores-assessment-aggby-skill-group",
    getParams: function (_a) {
        var filters = _a.filters, assessmentCategory = _a.assessmentCategory, skillGroup = _a.skillGroup, column1 = _a.column1, column2 = _a.column2, belowName = _a.belowName;
        var filterParams = getFilterParamString(__assign(__assign({}, (filters || {})), { assessmentCategory: cohortCategoryMapping[assessmentCategory] || assessmentCategory, skillGroup: skillGroup, column1: column1, column2: column2, belowName: belowName }));
        var params = "";
        if (skillGroup) {
            params += "skill_group=".concat(encodeURIComponent(skillGroup));
        }
        if (filterParams) {
            params += "".concat(params ? "&" : "").concat(filterParams);
        }
        return {
            asString: params,
            asObject: {},
        };
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: normalizeLeaderTableResponse(data) });
    },
});
export var useGetLeaderScoresAssessmentAggBySkillGroupQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/{reportId}/leader-scores-assessment-aggby-skill-group",
    getParams: function (_a) {
        var filters = _a.filters, reportId = _a.reportId, skillGroup = _a.skillGroup;
        var filterParams = getFilterParamString(filters);
        var params = "";
        if (skillGroup) {
            params += "skill_group=".concat(encodeURIComponent(skillGroup));
        }
        if (filterParams) {
            params += "".concat(params ? "&" : "").concat(filterParams);
        }
        return {
            asString: params,
            asObject: __assign({}, (reportId ? { reportId: reportId } : {})),
        };
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: normalizeLeaderTableResponse(data) });
    },
});
// ******************** Nine Box ********************
var getNineBoxThresholds = function (full) {
    var parts = full.split("-").map(Number);
    return [parts[0], parts[1]];
};
var axisFromData = function (_a) {
    var dataSources = _a.dataSources, axisLabel = _a.axisLabel, lowLabel = _a.lowLabel, midLabel = _a.midLabel, highLabel = _a.highLabel, lowThreshold = _a.lowThreshold, midThreshold = _a.midThreshold, highThreshold = _a.highThreshold, lowDescription = _a.lowDescription, midDescription = _a.midDescription, highDescription = _a.highDescription;
    return ({
        dataSources: dataSources,
        axisLabel: axisLabel,
        lowLabel: lowLabel,
        middleLabel: midLabel,
        highLabel: highLabel,
        lowThreshold: getNineBoxThresholds(lowThreshold),
        middleThreshold: getNineBoxThresholds(midThreshold),
        highThreshold: getNineBoxThresholds(highThreshold),
        lowDescription: lowDescription,
        middleDescription: midDescription,
        highDescription: highDescription,
    });
};
var normalizeBoxes = function (data) { return [
    data.boxOne,
    data.boxTwo,
    data.boxThree,
    data.boxFour,
    data.boxFive,
    data.boxSix,
    data.boxSeven,
    data.boxEight,
    data.boxNine,
]; };
var getBoxLabels = function (data) { return function (box) {
    var _a;
    if (!data) {
        return { xName: "", yName: "", xPlace: "", yPlace: "", name: "" };
    }
    var xAxis = data.xAxis, yAxis = data.yAxis;
    var name = (_a = normalizeBoxes(data)[box]) === null || _a === void 0 ? void 0 : _a.name;
    var xName = xAxis.axisLabel;
    var yName = yAxis.axisLabel;
    var xDataSources = xAxis.dataSources;
    var yDataSources = yAxis.dataSources;
    var xPlace = box < 3 ? xAxis.lowLabel : box < 6 ? xAxis.midLabel : xAxis.highLabel;
    var modulus = box % 3;
    var yPlace = modulus == 0
        ? yAxis.lowLabel
        : modulus == 1
            ? yAxis.midLabel
            : yAxis.highLabel;
    return { xName: xName, yName: yName, xPlace: xPlace, yPlace: yPlace, name: name, xDataSources: xDataSources, yDataSources: yDataSources };
}; };
export var AxisDataSource;
(function (AxisDataSource) {
    AxisDataSource["LeadershipTrajectory"] = "Potential,Capabilities";
    AxisDataSource["Performance"] = "Performance";
})(AxisDataSource || (AxisDataSource = {}));
var getAxisByDataSource = function (data) { return function (dataSource) {
    if (data.xAxis.dataSources.includes(dataSource)) {
        return data.xAxis;
    }
    if (data.yAxis.dataSources.includes(dataSource)) {
        return data.yAxis;
    }
}; };
var getScores = function (boxLeader) { return function (scoreType) {
    var _a, _b;
    var score = (_b = (_a = boxLeader === null || boxLeader === void 0 ? void 0 : boxLeader.leaderScores.find(function (_a) {
        var name = _a.name;
        return name == scoreType;
    })) === null || _a === void 0 ? void 0 : _a.score) === null || _b === void 0 ? void 0 : _b.toFixed(1);
    var categoricalResult = "Developing";
    if (score >= 5) {
        categoricalResult = "Expert";
    }
    else if (score >= 4) {
        categoricalResult = "Advanced";
    }
    else if (score >= 3) {
        categoricalResult = "Proficient";
    }
    else if (score >= 2) {
        categoricalResult = "Emerging";
    }
    return {
        score: score,
        categoricalResult: categoricalResult,
    };
}; };
var transformBoxLeader = function (data) { return function (original) {
    var _a;
    var _b, _c;
    return (__assign(__assign({}, original), { isMissingData: original.leaderScores.some(function (_a) {
            var score = _a.score;
            return score == null || score == undefined;
        }), recommendedBox: ((original === null || original === void 0 ? void 0 : original.recommendedBox) || 0) - 1, assignedBox: ((original === null || original === void 0 ? void 0 : original.assignedBox) || 0) - 1, movedTs: new Date(original.movedTs), timeInRoleYears: ((original.timeInRole || 0) / 60 / 60 / 24 / 365).toFixed(1), lastUpdatedTs: new Date(original.lastUpdatedTs), getRecommendedLabels: function () {
            return getBoxLabels(data)(((original === null || original === void 0 ? void 0 : original.recommendedBox) || 0) - 1);
        }, getAssignedLabels: function () { return getBoxLabels(data)(((original === null || original === void 0 ? void 0 : original.assignedBox) || 0) - 1); }, getTrajectoryMax: function () {
            return getNineBoxThresholds(getAxisByDataSource(data)(AxisDataSource.LeadershipTrajectory)
                .highThreshold)[1];
        }, trajectoryScores: (_a = {},
            _a[BoxLeaderScoreType.Potential] = getScores(original)(BoxLeaderScoreType.Potential),
            _a[BoxLeaderScoreType.Capabilities] = getScores(original)(BoxLeaderScoreType.Capabilities),
            _a), getPerformanceMax: function () {
            return getNineBoxThresholds(getAxisByDataSource(data)(AxisDataSource.Performance).highThreshold)[1];
        }, performanceScore: ((_b = original === null || original === void 0 ? void 0 : original.leaderScores.filter(function (_a) {
            var name = _a.name;
            return name == BoxLeaderScoreType.Performance;
        })[0]) === null || _b === void 0 ? void 0 : _b.score) || 0, performanceRatings: (_c = original === null || original === void 0 ? void 0 : original.performanceRatings) === null || _c === void 0 ? void 0 : _c.sort(function (a, b) {
            if (a.endDate < b.endDate) {
                return 1;
            }
            else if (a.endDate > b.endDate) {
                return -1;
            }
            return 0;
        }).map(function (rating) { return (__assign(__assign({}, rating), { endDate: new Date(rating.endDate) })); }) }));
}; };
export var createRestrictedCohortReport = createEndpointCall("{dashboard}/{ClientId}/cohort-report/create");
export var updateRestrictedCohortReport = updateEndpointCall("{dashboard}/{ClientId}/cohort-report/{id}");
export var useGetRestrictedCohortReport = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/cohort-report/create",
    getParams: function (_a) {
        var reportId = _a.reportId;
        return ({ reportId: reportId });
    },
    select: function (_a) {
        var data = _a.data;
        return ({
            data: __assign(__assign({}, data), { filters: __spreadArray(__spreadArray([], Object.entries(data.primaryFilters || {}), true), Object.entries(data.additionalFilters || {}), true).reduce(function (current, _a) {
                    var _b;
                    var key = _a[0], value = _a[1];
                    return (__assign(__assign({}, current), (_b = {}, _b[key] = value, _b)));
                }, {}) }),
        });
    },
});
export var useGetAvailableNineBoxes = getEndpointCall({
    endpoint: "{ninebox}/nine-box?clientId={ClientId}",
    getParams: function (_a) {
        var boxId = _a.boxId, completed = _a.completed;
        var params = "";
        if (boxId) {
            params += "boxId=".concat(boxId);
        }
        if (completed) {
            params += "completed=".concat(completed);
        }
        return params;
    },
    select: function (_a) {
        var data = _a.data;
        return ({
            data: data
                .filter(function (_a) {
                var boxId = _a.boxId;
                return boxId != "template";
            })
                .map(function (box) { return (__assign(__assign({}, box), { createdTs: new Date(box.createdTs), lastUpdatedTs: new Date(box.lastUpdatedTs), userPermissions: (box === null || box === void 0 ? void 0 : box.userPermissions) || [] })); }),
        });
    },
});
export var useGetAvailableCohortReports = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/cohort-report",
    getParams: function () {
        return "";
    },
    select: function (_a) {
        var data = _a.data;
        return ({
            data: (data || []).map(function (report) {
                var normalizedId = report._id || report.reportId || report.id;
                return __assign(__assign({}, report), { id: normalizedId, reportId: normalizedId, addedTs: new Date(report.addedTs), lastUpdatedTs: new Date(report.lastUpdatedTs) });
            }),
        });
    },
});
export var useGetSingleAvailableCohortReportsQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/cohort-report/{reportId}",
    getParams: function (_a) {
        var reportId = _a.reportId;
        return { reportId: reportId };
    },
    select: function (_a) {
        var data = _a.data;
        var assessmentCategory = data.assessmentCategory, name = data.name, reportFilters = data.reportFilters, addedTs = data.addedTs, lastUpdatedTs = data.lastUpdatedTs;
        var assessmentCategoryValue = assessmentCategoryMap[assessmentCategory] || Tab.CBI;
        return __assign(__assign({}, data), { assessmentCategory: assessmentCategoryValue, filters: (reportFilters === null || reportFilters === void 0 ? void 0 : reportFilters.reduce(function (current, _a) {
                var _b;
                var filterField = _a.filterField, filterValues = _a.filterValues;
                return (__assign(__assign({}, current), (_b = {}, _b[filterField] = filterValues || [], _b)));
            }, {})) || {}, reportName: name, addedTs: new Date(addedTs), lastUpdatedTs: new Date(lastUpdatedTs) });
    },
});
export var filterNameMapping = {
    functions: "functionFilter",
    subFunctions: "subFunctionFilter",
    projectId: "project",
};
var reverseFilterNameMapping = Object.entries(filterNameMapping).reduce(function (current, _a) {
    var _b;
    var key = _a[0], value = _a[1];
    return (__assign(__assign({}, current), (_b = {}, _b[value] = key, _b)));
}, {});
export var mapReverseFilterNames = function (filters) {
    return Object.entries(filters || {}).reduce(function (current, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        return (__assign(__assign({}, current), (_b = {}, _b[(reverseFilterNameMapping === null || reverseFilterNameMapping === void 0 ? void 0 : reverseFilterNameMapping[key]) || key] = value, _b)));
    }, {});
};
export var mergeFiltersAndRestrictions = function (restrictions, filters) {
    return Object.entries(restrictions || {}).reduce(function (current, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        var filterName = (filterNameMapping === null || filterNameMapping === void 0 ? void 0 : filterNameMapping[key]) || key;
        if ((((current === null || current === void 0 ? void 0 : current[filterName]) || []).length == 0 && value.size > 0) ||
            value.size == 1) {
            return __assign(__assign({}, current), (_b = {}, _b[filterName] = Array.from(value), _b));
        }
        return current;
    }, filters);
};
export var useGetFilteredNineBox = function (_a) {
    var id = _a.id, assigned_box = _a.assigned_box;
    var getFilters = useContext(FilterContext).getFilters;
    var restrictions = useContext(FilterRestrictionContext).restrictions;
    var filters = mergeFiltersAndRestrictions(restrictions, getFilters());
    var ninebox = useGetNineBox({ id: id, assigned_box: assigned_box, filters: filters });
    return ninebox;
};
export var useGetNineBox = getEndpointCall({
    endpoint: "{ninebox}/nine-box/{id}",
    getParams: function (_a) {
        var filters = _a.filters, id = _a.id, assigned_box = _a.assigned_box;
        // Avoid conflicts with global assigned_box filter
        var filterString = getLeaderScoresParamString(__assign(__assign({}, filters), { assigned_box: [] }));
        return {
            asString: "".concat(filterString).concat(assigned_box ? "&assigned_box=" + encode(assigned_box) : ""),
            asObject: { id: id },
        };
    },
    select: function (_a) {
        var data = _a.data;
        return ({
            data: {
                id: data.id,
                clientId: data.clientId,
                createUser: __assign({}, data.createUser),
                boxId: data.boxId,
                boxName: data.boxName,
                version: data.version,
                versionName: data.versionName,
                filters: __assign({}, data.filters),
                xAxis: axisFromData(data.xAxis),
                yAxis: axisFromData(data.yAxis),
                boxes: normalizeBoxes(data),
                boxByIndex: function (index) {
                    return ({
                        1: data.boxOne,
                        2: data.boxTwo,
                        3: data.boxThree,
                        4: data.boxFour,
                        5: data.boxFive,
                        6: data.boxSix,
                        7: data.boxSeven,
                        8: data.boxEight,
                        9: data.boxNine,
                    }[index]);
                },
                leaders: data.boxLeaders.map(transformBoxLeader(data)),
                createdTs: new Date(data.createdTs),
                lastUpdatedTs: new Date(data.lastUpdatedTs),
                updateUser: data.updateUser,
                userPermissions: data.userPermissions || [],
            },
        });
    },
});
export var useGetNineBoxCategoriesFilter = getEndpointCall({
    endpoint: "{ninebox}/nine-box/{id}/categories",
    getParams: function (_a) {
        var filters = _a.filters, id = _a.id;
        var filterString = getLeaderScoresParamString(filters);
        return {
            asString: filterString,
            asObject: { id: id },
        };
    },
    select: function (_a) {
        var data = _a.data;
        return ({
            data: {
                boxes: [
                    __assign(__assign({}, data[0].boxOne), { assignedId: 1 }),
                    __assign(__assign({}, data[0].boxTwo), { assignedId: 2 }),
                    __assign(__assign({}, data[0].boxThree), { assignedId: 3 }),
                    __assign(__assign({}, data[0].boxFour), { assignedId: 4 }),
                    __assign(__assign({}, data[0].boxFive), { assignedId: 5 }),
                    __assign(__assign({}, data[0].boxSix), { assignedId: 6 }),
                    __assign(__assign({}, data[0].boxSeven), { assignedId: 7 }),
                    __assign(__assign({}, data[0].boxEight), { assignedId: 8 }),
                    __assign(__assign({}, data[0].boxNine), { assignedId: 9 }),
                ],
            },
        });
    },
});
export var useGetNineBoxLeaderCountWithFilters = getEndpointCall({
    endpoint: "{ninebox}/nine-box/{clientId}/leader-count",
    getParams: function (_a) {
        var filters = _a.filters, clientId = _a.clientId;
        var filterString = getLeaderScoresParamString(filters);
        return {
            asString: filterString,
            asObject: { clientId: clientId },
        };
    },
    select: function (_a) {
        var data = _a.data;
        return { data: data };
    },
});
export var createNineBoxQuery = createEndpointCall("{ninebox}/nine-box");
export var deleteNineBoxQuery = deleteEndpointCall("{ninebox}/nine-box?boxId={boxId}");
export var deleteCohortReportMutation = deleteEndpointCall("{dashboard}/{ClientId}/cohort-report/{reportId}");
export var newVersionNineBoxQuery = putEndpointCall("{ninebox}/nine-box/{id}/new-version");
export var revertVersionNineBoxQuery = putEndpointCall("{ninebox}/nine-box/{id}/revert-version");
export var NineBoxSwitchAxisQuery = putEndpointCall("{ninebox}/nine-box/{id}/switch-axis");
export var updateNineBoxSettingsQuery = updateEndpointCall("{ninebox}/nine-box/{id}/settings");
export var updateNineBoxLeadersQuery = updateEndpointCall("{ninebox}/nine-box/{id}/box-leaders");
export var addNineBoxAuditLogQuery = updateEndpointCall("{ninebox}/nine-box/{id}/audit-log");
export var downloadCsvFile = function (baseFilename, url, onSuccess) { return __awaiter(void 0, void 0, void 0, function () {
    var anchor, headers;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                anchor = document.createElement("a");
                document.body.appendChild(anchor);
                return [4 /*yield*/, getHeaders()];
            case 1:
                headers = _a.sent();
                fetch(url, { headers: headers })
                    .then(function (response) {
                    return response.blob();
                })
                    .then(function (blob) {
                    var objectUrl = window.URL.createObjectURL(blob);
                    anchor.href = objectUrl;
                    anchor.download = baseFilename;
                    anchor.click();
                    window.URL.revokeObjectURL(objectUrl);
                    onSuccess();
                });
                return [2 /*return*/];
        }
    });
}); };
export var formattedDate = function (inputDateTime) {
    var newDateFormat = new Date(inputDateTime).toLocaleDateString("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric",
    });
    return newDateFormat;
};
export var formattedTime = function (inputDateTime) {
    var newTimeFormat = new Date("".concat(inputDateTime, " UTC")).toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
    });
    return newTimeFormat;
};
export var getBoxesWithLabels = function (data) {
    var boxes = [];
    data.boxes.forEach(function (item, index) {
        var nbox = {
            index: index,
            name: item.name,
            boxDescription: item.boxDescription,
            lastUpdatedTs: item.lastUpdatedTs,
            xlabel: data.xAxis.axisLabel,
            ylabel: data.yAxis.axisLabel,
            xDataSources: data.xAxis.dataSources,
            yDataSources: data.yAxis.dataSources,
            xplace: "",
            yplace: "",
        };
        var indexToLabel = {
            0: { xplace: data.xAxis.lowLabel, yplace: data.yAxis.lowLabel },
            1: { xplace: data.xAxis.lowLabel, yplace: data.yAxis.middleLabel },
            2: { xplace: data.xAxis.lowLabel, yplace: data.yAxis.highLabel },
            3: { xplace: data.xAxis.middleLabel, yplace: data.yAxis.lowLabel },
            4: { xplace: data.xAxis.middleLabel, yplace: data.yAxis.middleLabel },
            5: { xplace: data.xAxis.middleLabel, yplace: data.yAxis.highLabel },
            6: { xplace: data.xAxis.highLabel, yplace: data.yAxis.lowLabel },
            7: { xplace: data.xAxis.highLabel, yplace: data.yAxis.middleLabel },
            8: { xplace: data.xAxis.highLabel, yplace: data.yAxis.highLabel },
        };
        nbox.xplace = indexToLabel[index].xplace;
        nbox.yplace = indexToLabel[index].yplace;
        boxes.push(nbox);
    });
    return boxes;
};
export var generateFileName = function (_a) {
    var fileName = _a.fileName, clientName = _a.clientName, format = _a.format;
    var date = new Date();
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, "0");
    var day = String(date.getDate()).padStart(2, "0");
    var file = fileName ? "".concat(fileName, "_") : "";
    var client = clientName ? "".concat(clientName, "_") : "";
    var baseFilename = "".concat(file).concat(client).concat(year, "_").concat(month, "_").concat(day).concat(format);
    return baseFilename;
};
export var useGetLeaderCohortInsightsStrengthsWeaknessesQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/top-strengths-weaknesses",
    getParams: function (_a) {
        var filters = _a.filters;
        return getLeaderScoresParamString(filters);
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetLeaderCohortInsightsLowestOpportunitiesQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leadership/lowest-groups",
    getParams: function (_a) {
        var filters = _a.filters;
        return getLeaderScoresParamString(filters);
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
export var useGetLeaderScoreCategoriesQuery = getEndpointCall({
    endpoint: "{dashboard}/{ClientId}/leadership/leader-score-categories",
    getParams: function (_a) {
        var filters = _a.filters, score_type = _a.score_type;
        var filterParams = getLeaderScoresParamString(filters);
        var params = "";
        if (score_type) {
            params += "score_type=".concat(score_type);
        }
        if (filterParams) {
            params += "".concat(params ? "&" : "").concat(filterParams);
        }
        return params;
    },
    select: function (_a) {
        var data = _a.data;
        return ({ data: data });
    },
});
// ******************** Cohort Report ********************
export var useValidateUniqueCohortReportNameMutation = createEndpointCall("{dashboard}/{ClientId}/cohort-report/validate-name");
